// extracted by mini-css-extract-plugin
export default {"root":"oTOhtB1vnS","root_pinned":"AXhCnRKkGy","root_noPadding":"VNyxMuNK1H","header":"aEPnvtFqVF","body":"maF3QH89zF","title":"t9I1mzLlsy","segmentedControlContainer":"gaJ8JRM_86"};